<template>
    <div style="width:100%;height: 100%;">
        <template v-if="numberConfig.name === 'loginUserCount'">
            <p class="colorBlue" style="font-size: .2rem;">{{numberConfig.title}}
<!--                (共{{totalUserCount}}人)-->
            </p>
        </template>
        <template v-else>
            <p class="colorBlue" style="font-size: .2rem;">{{numberConfig.title}}</p>
        </template>
        <div>
            <dv-digital-flop :config="numberConfig" style="width:1.25rem;height: .6rem;" />                        
        </div>
    </div>
</template>

<script>
    export default {
        name: "topSalemoney",
        props:{
            numberConfig: {
                type:Object,
                default:()=>{
                    return{
                        title:'月度总销售额',
                        name:'月度总销售额',
                        number:[4119999898],
                        //content: '{nt}元',
                        content: '{nt}',
                        style:{fontSize: 12},
                      
                    }
                }
            },
            totalUserCount: {
                type:Number,
                default: 0,
            }
        },
        methods: {
             formatter (number) {
                const numbers = number.toString().split('').reverse()
                const segs = []
                while (numbers.length) segs.push(numbers.splice(0, 3).join(''))
                return segs.join(',').split('').reverse().join('')
                },

        },
    }
</script>

<style scoped>

</style>

